import React from 'react';
import { Button, Center, Stack, Text } from '@mantine/core';
import { useSiteConfig } from '@/context/SiteConfigContext';

/**
 * Full-screen error view shown when startup configuration fails to load
 * and no valid cached configuration is available. Includes a Retry action
 * that calls the provider's `refresh()`.
 */
export default function ConnectionErrorScreen() {
  const { error, retry } = useSiteConfig();

  return (
    <Center w="100vw" h="100vh" role="alert" aria-live="assertive">
      <Stack align="center" gap="sm">
        <Text fw={600} size="lg">Unable to connect</Text>
        <Text c="dimmed" ta="center" maw={420}>
          We couldn't load the site configuration. Check your connection and try again.
        </Text>
        {error && (
          <Text size="xs" c="red" ta="center" maw={520} style={{ whiteSpace: 'pre-wrap' }}>
            {String(error)}
          </Text>
        )}
        <Button onClick={retry} variant="filled">Retry</Button>
      </Stack>
    </Center>
  );
}
